import React from 'react';
import * as S from './style';
import { t } from 'i18next';
import { useContext } from 'react';
import { ThemeContext } from '@/theme/ThemeProvider';

export default function SignUpButton() {
  const { isDarkMode } = useContext(ThemeContext);
  return <S.GraButton to="/signup" isDarkMode={isDarkMode}>{t('signUp')}</S.GraButton>;
}
